import { AlertListTenantAdminKey } from "../actions/tenantAdminActions";

const initialState = {     
      selectedTenantAdminType : AlertListTenantAdminKey
}

const tenantAdminTypeReducer = (state = initialState, action) => {
      switch (action.type) {
            case 'SET_SELECTED_TENANT_ADMIN_TYPE':
                  return {
                        selectedTenantAdminType: action.selectedTenantAdminType  
                  }
            default:
                  return state;
      }
     
};
export default tenantAdminTypeReducer;